// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `fic-screen-content {
  display: block;
  flex: 1;
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fic-screen/content/fic-screen-content.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,OAAA;EACA,cAAA;AACJ","sourcesContent":["fic-screen-content {\r\n    display: block;\r\n    flex: 1;\r\n    overflow: auto;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
